// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true
	}
};

// Declare Templates
var bcSfFilterTemplate = {
	'saleLabelHtml': '<div class="sale_banner">' + bcSfFilterConfig.label.sale + '</div>',
	'newLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.new + '</div>',
	'comingsoonLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.coming_soon + '</div>',
	'preorderLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.pre_order + '</div>',
	'reviewHtml': '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>',
	'vendorHtml': '<div class="vendor"><span itemprop="brand">{{itemVendorLabel}}</span></div>',
	'quickViewBtnHtml': '<div data-fancybox-href="#product-{{itemId}}" class="quick_shop action_button" data-gallery="product-{{itemId}}-gallery">' + bcSfFilterConfig.label.quick_shop + '</div>',
	'newRowHtml': '<br class="clear product_clear" />',

	// Grid Template
	'productGridItemHtml': '<div data-boost-theme-quickview="{{itemId}}" class="{{itemColumnNumberClass}} {{itemCollectionGroupThumbClass}} thumbnail {{itemCollectionGroupMobileClass}} {{itemPriceAlignClass}}">' +
								'<a href="{{itemUrl}}">' +
									'<div class="relative product_image">' +
										'<div class="product_container {{itemFlipImageClass}}">' +
											'{{itemImages}}' +
										'</div>' +	
									'</div>' +
									'<div class="info">' +
										'<div class="info__text">' +
											'<span class="title">{{itemTitle}}</span>' +
											'{{itemReviews}}' +
											'{{itemVendor}}' +
										'</div>' +
										'{{itemPrice}}' +
									'</div>' +
									'<div class="banner_holder">' +
										'{{itemSaleLabel}}' +
										'{{itemNewLabel}}' +
										'{{itemComingsoonLabel}}' +
										'{{itemPreorderLabel}}' +
									'</div>' +
								'</a>' +
								'{{itemQuickViewBtn}}' +
								'{{itemSwatch}}' +
							'</div>' +
							'{{itemNewRow}}',

	// Pagination Template
	'previousHtml': '<span class="prev"><a href="{{itemUrl}}">« ' + bcSfFilterConfig.label.paginate_prev + '</a></span>',
	'nextHtml': '<span class="next"><a href="{{itemUrl}}">' + bcSfFilterConfig.label.paginate_next + ' »</a></span>',
	'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
	'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '<span class="deco">{{itemTitle}}</span>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
	// Sorting Template
	'sortingHtml': '<label for="bc-sf-filter-top-sorting-select" class="inline">' + bcSfFilterConfig.label.sorting + '</label> <select id="bc-sf-filter-top-sorting-select" class="sort_by">{{sortingItems}}</select>',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
	/*** Prepare data ***/
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices

	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	var saleClass = onSale ? 'sale' : '';
	var soldOutClass = soldOut ? 'out_of_stock' : 'in_stock';

	var itemColumnNumberClass = '';
	var itemCollectionGroupThumbClass = buildItemCollectionGroupThumbClass(index, bcSfFilterConfig.custom.products_per_row);
	var itemCollectionGroupMobileClass = (index - 1) % 2 == 0 ? 'even' : 'odd';
	var itemPriceAlignClass = 'price_align--' + bcSfFilterConfig.custom.collection_price_position;
	switch (bcSfFilterConfig.custom.products_per_row) {
		case 2: itemColumnNumberClass = bcSfFilterConfig.custom.show_sidebar ? 'six columns' : 'six columns'; break;
		case 3: itemColumnNumberClass = bcSfFilterConfig.custom.show_sidebar ? 'four columns' : 'one-third column'; break;
		default: itemColumnNumberClass = bcSfFilterConfig.custom.show_sidebar ? 'three columns' : 'four columns'; break;
	}
	itemHtml = itemHtml.replace(/{{itemColumnNumberClass}}/g, itemColumnNumberClass);
	itemHtml = itemHtml.replace(/{{itemCollectionGroupThumbClass}}/g, itemCollectionGroupThumbClass);
	itemHtml = itemHtml.replace(/{{itemCollectionGroupMobileClass}}/g, itemCollectionGroupMobileClass);
	itemHtml = itemHtml.replace(/{{itemPriceAlignClass}}/g, itemPriceAlignClass);

	// Add onSale label
	var itemSaleLabel = bcSfFilterConfig.custom.sale_banner_enabled && onSale ? bcSfFilterTemplate.saleLabelHtml : '';
	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

	// Add Label (New, Coming soon, Pre order)
	var itemNewLabelHtml = '', itemComingsoonLabelHtml = '', itemPreorderLabelHtml = '';
	if (data.collections) {
		var newLabel = data.collections.filter(function (e) { return e.handle == 'new'; });
		itemNewLabelHtml = typeof newLabel[0] != 'undefined' ? '<div class="new_banner">' + bcSfFilterConfig.label.new + '</div>' : '';

		var comingsoonLabel = data.collections.filter(function (e) { return e.handle == 'coming-soon'; });
		itemComingsoonLabelHtml = typeof comingsoonLabel[0] != 'undefined' ? '<div class="new_banner">' + bcSfFilterConfig.label.coming_soon + '</div>' : '';

		var preorderLabel = data.collections.filter(function (e) { return e.handle == 'pre-order'; });
		itemPreorderLabelHtml = typeof preorderLabel[0] != 'undefined' ? '<div class="new_banner">' + bcSfFilterConfig.label.pre_order + '</div>' : '';
	}
	itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
	itemHtml = itemHtml.replace(/{{itemComingsoonLabel}}/g, itemComingsoonLabelHtml);
	itemHtml = itemHtml.replace(/{{itemPreorderLabel}}/g, itemPreorderLabelHtml);

	// Add Quick view button
	var itemQuickViewBtnHtml = bcSfFilterConfig.custom.quick_shop_enabled ? bcSfFilterTemplate.quickViewBtnHtml : '';
	itemHtml = itemHtml.replace(/{{itemQuickViewBtn}}/g, itemQuickViewBtnHtml);

	// Add Images
	var itemImagesHtml = buildImages(data);
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	// Add Flip Image Class
	var itemFlipImageClass = (images && images.length > 1 && bcSfFilterConfig.custom.collection_secondary_image) ? 'swap-true' : 'swap-false';
	itemHtml = itemHtml.replace(/{{itemFlipImageClass}}/g, itemFlipImageClass);

	// Add Reviews
	var itemReviewsHtml = bcSfFilterConfig.custom.enable_shopify_collection_badges ? bcSfFilterTemplate.reviewHtml : '';
	itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

	// Add Vendor
	var itemVendorHtml = bcSfFilterConfig.custom.display_vendor_collection ? bcSfFilterTemplate.vendorHtml : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

	// Add Price
	var itemPriceHtml = '';
// 	itemPriceHtml += '<span class="price ' + saleClass + '" itemprop="offers" itemscope itemtype="http://schema.org/Offer">';
// 	itemPriceHtml += '<meta itemprop="price" content="' + this.formatMoney(data.price_min, this.moneyFormat) + '" />';
// 	itemPriceHtml += '<meta itemprop="priceCurrency" content="' + bcSfFilterConfig.shop.currency + '" />';
// 	itemPriceHtml += '<meta itemprop="seller" content="' + bcSfFilterConfig.shop.name + '" />';
// 	itemPriceHtml += '<meta itemprop="availability" content="' + soldOutClass + '" />';
// 	itemPriceHtml += '<meta itemprop="itemCondition" content="New" />';
// 	if (!soldOut) {
// 		if (priceVaries && data.price_min > 0) {
// 			itemPriceHtml += '<small><em>' + bcSfFilterConfig.label.from_price + '</em></small> ';
// 		}
// 		if (data.price_min > 0) {
// 			itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
// 		} else {
// 			itemPriceHtml += bcSfFilterConfig.label.free_price;
// 		}
// 	} else {
// 		itemPriceHtml += '<span class="sold_out">' + bcSfFilterConfig.label.sold_out + '</span>';
// 	}
// 	if (onSale) {
// 		itemPriceHtml += ' <span class="was_price"><span class="money">' + this.formatMoney(data.compare_at_price_max * 100, this.moneyFormat) + '</span></span>';
// 	}
// 	itemPriceHtml += '</span>';
  	var onSaleClass = onSale ? 'sale' : '';
    itemPriceHtml += '<span class="price ' + onSaleClass + '">';
    if (!soldOut) {
      if (priceVaries && data.price_min > 0) {
        itemPriceHtml += '<small><em>' + bcSfFilterConfig.label.from_price + '</em></small> ';
      }
      if (data.price_min > 0) {
        itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
      } else {
        itemPriceHtml += bcSfFilterConfig.label.free_price;
      }
    } else {
      itemPriceHtml += '<span class="sold_out">' + bcSfFilterConfig.label.sold_out + '</span>';
    }
    if (onSale) {
      itemPriceHtml += ' <span class="was_price"><span class="money">' + this.formatMoney(data.compare_at_price_max) + '</span></span>';
    }
    itemPriceHtml += '</span>';
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add swatch
	var itemSwatchHtml = buildSwatch(data);
	itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

	// Add new row
	var itemNewRowHtml = index % bcSfFilterConfig.custom.products_per_row == 0 ? bcSfFilterTemplate.newRowHtml : '';
	itemHtml = itemHtml.replace(/{{itemNewRow}}/g, itemNewRowHtml);

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	return itemHtml;
};

// Build advanced class
function buildItemCollectionGroupThumbClass(index, productsPerRow) {
	var temp = index < productsPerRow ? index : index % productsPerRow;
	if (temp == 0) { return 'omega'; }
	else if (temp == 1) { return 'alpha'; }
	return '';
}

function buildImages(data){
	var images = data.images_info;
	if (!images || images.length == 0){
		images = [];
		images.push({
			src: bcSfFilterMainConfig.general.no_image_url,
			width: 480,
			height: 480
		})
	}

	var maxWidth = images[0].width;
	if (bcSfFilterConfig.custom.align_height && bcSfFilterConfig.custom.collection_height){
		var aspectRatio = images[0].width / images[0].height;
		maxWidth = aspectRatio * bcSfFilterConfig.custom.collection_height;
	}

	var alignHeightStyle = images[0].width > images[0].height ? ' height: auto;' : '';

	var html = '<div class="image__container" style="max-width: '+ maxWidth +'px;">' +
					'<img src="'+ bcsffilter.optimizeImage(images[0].src, '300x') +'"' +
						  ' alt="{{itemTitle}}"' +
						  ' class="lazyload lazyload--fade-in"' +
						  ' style="width: 100%; max-width: '+ images[0].width +'px; '+ alignHeightStyle +'"' +
						  ' data-sizes="auto"' +
						  ' data-src="'+ bcsffilter.optimizeImage(images[0].src, '2048x') +'"' +
						  ' data-srcset="'+ bgset(images[0]) +'"/>' +
					'{{flipImageHtml}}' +
				  '</div>';
	
	var flipImageHtml = '';
	if (images.length > 1 && bcSfFilterConfig.custom.collection_secondary_image){
	flipImageHtml = '<div class="image__container" style="max-width: '+ images[1].width +'">' +
						'<img src="'+ bcsffilter.optimizeImage(images[1].src, '900x') +'"' +
						' class="secondary lazyload"' +
						' alt="{{itemTitle}}"/>' +
						'</div>';
	}
	html = html.replace(/{{flipImageHtml}}/g, flipImageHtml);
	return html;
}

function buildSwatch(data){
	var html = '';
	var values = [];
	var swatchItems = [];
	if (bcSfFilterConfig.custom.collection_swatches){
		data.variants.forEach(function(variant){
			var colorValue = '';
			variant.merged_options.forEach(function(option){
				var key = option.split(':')[0].toLowerCase();
				var value = option.split(':')[1];
				if ((key.indexOf('color') != -1 || key.indexOf('colour') != -1 || key.indexOf('material') != -1) && values.indexOf(value.toLowerCase()) == -1){
					values.push(value.toLowerCase());
					colorValue = value;
				}
			});
			if (colorValue){
				var colorImage = bcSfFilterMainConfig.general.asset_url.split('bc-sf-filter.js')[0] + bcsffilter.slugify(colorValue) + '_50x.png';
				var colorBackground = bcsffilter.slugify(colorValue).split('-').pop();
				var variantUrl = bcsffilter.buildProductItemUrl(data) + '?v=' + variant.id;
				var variantImage = variant.image ? bcsffilter.optimizeImage(variant.image, '480x') : bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url, '480x');
				var swatchItem = '<a href="' + variantUrl + '" class="swatch">' +
									'<span data-image="'+ variantImage +'" style="background-image: url('+ colorImage +'); background-color: '+ colorBackground +';"></span>' +
			  					'</a>';
				swatchItems.push(swatchItem);				  	  
			}
		})
	}
	if (swatchItems.length > 0){
		html = '<div class="collection_swatches">' + swatchItems.join(' ') + '</div>';
	}
	return html;
}

function bgset(image) {
	var bgset = '';
	if (image) {
		var aspect_ratio = image.width / image.height;

		if (image.width > 180) bgset += ' ' + bcsffilter.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
		if (image.width > 360) bgset += ' ' + bcsffilter.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
		if (image.width > 540) bgset += ' ' + bcsffilter.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
		if (image.width > 720) bgset += ' ' + bcsffilter.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
		if (image.width > 900) bgset += ' ' + bcsffilter.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
		if (image.width > 1080) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
		if (image.width > 1296) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
		if (image.width > 1512) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
		if (image.width > 1728) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
		if (image.width > 1950) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
		if (image.width > 2100) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
		if (image.width > 2260) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
		if (image.width > 2450) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
		if (image.width > 2700) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
		if (image.width > 3000) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
		if (image.width > 3350) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
		if (image.width > 3750) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
		if (image.width > 4100) bgset += ' ' + bcsffilter.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
		bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
	}
	return bgset;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}

	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		jQ(this.selector.pagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content 
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function (colData, apiData) {
	if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
		var colInfo = colData.collection;
		var breadcrumbHtml = '<span itemscope itemtype="http://data-vocabulary.org/Breadcrumb"><a href="/" title="' + bcSfFilterConfig.shop.name + '"><span itemprop="title">' + bcSfFilterConfig.label.breadcrumb_home + '</span></a></span>';
		breadcrumbHtml += ' <span class="icon-right-arrow"></span>';
		breadcrumbHtml += ' <span itemscope itemtype="http://data-vocabulary.org/Breadcrumb"><a href="/collections' + colInfo.handle + '" title="' + colInfo.title + '" itemprop="url"><span itemprop="title">' + colInfo.title + '</span></a></span>';
		breadcrumbHtml += ' <span id="bc-sf-filter-top-pagination"></span>';
		jQ('.breadcrumb').html(breadcrumbHtml);
	}
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data) {
	// Build content for Quick view
	if (!this.isMobile() && bcSfFilterConfig.custom.quick_shop_enabled) {
		this.buildExtrasProductListByAjax(data, 'boost-integration', function(results){
            results.forEach(function(result, index){
                // Append the custom html to product item
                jQ(result.quickshop_html).insertAfter(jQ('[data-boost-theme-quickview="'+ result.id+ '"]'));
                if(index == results.length - 1){
                  buildTheme();
                }
            })
        });
	}
  
  /* start-boost-37587 */
  buildTheme();
  /* endb-boost-37587 */
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data) {
	// Add Wrapper for Product list
	if (jQ('#bc-sf-filter-products').children().hasClass('product-list') || jQ('#bc-sf-filter-products').children().hasClass('products')) {
		jQ('#bc-sf-filter-products').children().children().unwrap();
	}

	// Build Top Pagination
	var totalPage = Math.ceil(data.total_product / this.queryParams.limit);
	var topPaginationHtml = ' <span class="icon-right-arrow"></span> ' + (bcSfFilterConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, this.queryParams.page).replace(/{{ pages }}/g, totalPage);
	jQ('#bc-sf-filter-top-pagination').html(topPaginationHtml);
};

function buildTheme(){
	if (typeof window.lazyload == 'function'){
		lazyload();		
	}	
	if (bcSfFilterConfig.custom.show_multiple_currencies && typeof window.convertCurrencies == 'function'){
		convertCurrencies();
	}
	collection.init();
	product.init();
	Shopify.PaymentButton.init();
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
